import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { appRoutePaths } from '../../components/Root/navigation';
import {
  accessRouteRef,
  groupsRouteRef,
  homeRouteRef,
  searchRouteRef,
  settingsRouteRef,
} from './routes';

const homePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: appRoutePaths.home,
    routeRef: homeRouteRef,
    noHeader: true,
    loader: () =>
      import('../../components/home/HomePage').then(module => (
        <module.HomePage />
      )),
  },
});

const searchPage = PageBlueprint.make({
  name: 'search',
  params: {
    path: appRoutePaths.search,
    routeRef: searchRouteRef,
    noHeader: true,
    loader: () =>
      import('../../components/search/SearchPage').then(
        module => module.searchPage,
      ),
  },
});

const settingsPage = PageBlueprint.make({
  name: 'settings',
  params: {
    path: appRoutePaths.settings,
    routeRef: settingsRouteRef,
    noHeader: true,
    loader: () =>
      import('../../components/settings/TegelSettingsPage').then(module => (
        <module.TegelSettingsPage />
      )),
  },
});

const groupsPage = PageBlueprint.make({
  name: 'groups',
  params: {
    path: appRoutePaths.groups,
    routeRef: groupsRouteRef,
    noHeader: true,
    loader: () =>
      import('../../components/groups').then(module => <module.GroupsPage />),
  },
});

const accessPage = PageBlueprint.make({
  name: 'access',
  params: {
    path: appRoutePaths.access,
    routeRef: accessRouteRef,
    noHeader: true,
    loader: () =>
      import('../../components/selfservice/SelfServicePage').then(module => (
        <module.SelfServicePage />
      )),
  },
});

export const drivelinePlugin = createFrontendPlugin({
  pluginId: 'driveline',
  extensions: [
    homePage,
    searchPage,
    settingsPage,
    groupsPage,
    accessPage,
  ],
  routes: {
    access: accessRouteRef,
    groups: groupsRouteRef,
    home: homeRouteRef,
    search: searchRouteRef,
    settings: settingsRouteRef,
  },
});
